import { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import "moment-timezone";
import { removeItemsFromArray } from "../../utils/array.js";
import { selectOptionFilter } from "./utils.js";
const selectAllOptionValue = "all";
function useMultiSelect({
  defaultSelectAll,
  mode = "client",
  options,
  value,
  onApply,
  onPageChange,
  onSelectAll,
  onSubmit
}) {
  const [selectedValue, setSelectedValue] = useState([]);
  const [selectOpen, setSelectOpen] = useState(false);
  const [selectAll, setSelectAll] = useState(defaultSelectAll);
  const [expandValue, setExpandValue] = useState([]);
  useEffect(() => {
    setSelectAll(defaultSelectAll);
  }, [defaultSelectAll]);
  useEffect(() => {
    if (value) {
      setSelectedValue(value);
    }
  }, [Array.isArray(value) ? value.join() : value]);
  const handleClose = () => {
    setSelectOpen(false);
  };
  const handleOpen = () => {
    setSelectOpen(true);
  };
  function handleGroupChange(initArray, updatedArray) {
    const fullSet = /* @__PURE__ */ new Set([...initArray, ...updatedArray]);
    if ([...fullSet].length > initArray.length) {
      return [...fullSet];
    }
    return removeItemsFromArray(initArray, ...updatedArray);
  }
  function handleChange(event) {
    const value2 = event.target.value;
    const array = Array.isArray(value2) ? value2 : [value2];
    let result = array;
    if (array.length > 0 && Array.isArray(array[array.length - 1])) {
      const updatedArray = array.splice(-1, 1)[0];
      result = handleGroupChange(array, updatedArray);
    }
    if (result[result.length - 1] !== selectAllOptionValue) {
      setSelectedValue(result);
      onSubmit(result.length > 0 ? result : null);
    }
  }
  function handleExpand(item) {
    const stringItem = item.toString();
    if (!expandValue?.includes(stringItem)) {
      setExpandValue([...expandValue, stringItem]);
    }
  }
  function handleCollapse(item) {
    const stringItem = item.toString();
    if (expandValue?.includes(stringItem)) {
      setExpandValue(removeItemsFromArray(expandValue, stringItem));
    }
  }
  function handleItemClick(itemValue) {
    let result;
    if (selectedValue?.includes(itemValue)) {
      result = removeItemsFromArray(selectedValue, itemValue);
    } else {
      result = [...selectedValue, itemValue];
    }
    handleChange({ target: { value: result } });
  }
  function handleClearSelection(e) {
    e.stopPropagation();
    setSelectedValue([]);
    onSubmit(null);
  }
  function handleSelectAll() {
    if (onSelectAll) {
      onSelectAll(!selectAll);
    } else {
      const newValue = selectAll ? [] : options?.map((o) => o.value);
      setSelectedValue(newValue);
      onSubmit(newValue);
      setSelectAll(!selectAll);
    }
  }
  function handleFilterChange(page) {
    if (mode === "client") {
      throw new Error("method not implemented");
    } else {
      onPageChange(page);
    }
  }
  function handleApply() {
    if (onApply) {
      onApply();
    }
    handleClose();
  }
  return {
    expandValue,
    selectAll,
    selectOpen,
    selectedValue,
    handleApply,
    handleChange,
    handleClearSelection,
    handleClose,
    handleCollapse,
    handleExpand,
    handleFilterChange,
    handleItemClick,
    handleOpen,
    handleSelectAll
  };
}
function useSearch({ options, mode, onFilterChange }) {
  const { formatMessage } = useIntl();
  const [visibleOptions, setVisibleOptions] = useState(options);
  const [inputValue, setInputValue] = useState("");
  useEffect(() => {
    if (options) {
      setVisibleOptions(options);
    }
  }, [options?.map((o) => `${o.label}${o.value}`).join()]);
  function handleSearchChange(e) {
    e.stopPropagation();
    const filterValue = e.target.value;
    setInputValue(filterValue);
    if (mode === "client") {
      const filteredOptions = selectOptionFilter(getFormattedOptions(options), filterValue);
      setVisibleOptions(filteredOptions);
      if (onFilterChange) {
        onFilterChange(filterValue);
      }
    } else {
      onFilterChange(filterValue);
    }
  }
  function getFormattedOptions(options2) {
    return options2?.map((o) => ({ ...o, label: o?.label ? typeof o.label === "string" ? o.label : formatMessage(o.label) : null }));
  }
  return {
    inputValue,
    visibleOptions,
    handleSearchChange
  };
}
export {
  selectAllOptionValue,
  useMultiSelect,
  useSearch
};
//# sourceMappingURL=hooks.js.map
